import { useCallback } from 'react'
import { useArchiveProgrammaticCampaignMutation } from '../../__generated__/graphql'
import { TradingDeskRouteBuilder } from '../../pages/routeParams'
import { useCurrentCompanyDisplayedContext } from '../../pages/company/currentCompanyDisplayedContext'
import { useAfterArchiveEntity } from './useAfterArchiveEntity'

export const useArchiveProgrammaticCampaignAction = (
  campaignId: string
): { onArchive: () => Promise<void>; archiving: boolean } => {
  const {
    company: { slug },
  } = useCurrentCompanyDisplayedContext()
  const runAfterArchive = useAfterArchiveEntity()
  const [archiveProgrammaticCampaign, { loading: archiving }] = useArchiveProgrammaticCampaignMutation()

  const onArchive = useCallback(async () => {
    await runAfterArchive(TradingDeskRouteBuilder(slug), () =>
      archiveProgrammaticCampaign({ variables: { campaignId } })
    )
  }, [archiveProgrammaticCampaign, campaignId, runAfterArchive, slug])

  return { onArchive, archiving }
}
